<template lang="pug">
.footer-area-wrapper.reveal-footer.bg-gray
  .footer-area

  .cop-footer.footer-copyright-area
    .container
      .row.align-items-center
        .col-md-6.text-center.text-md-left
          span.copyright-text
            | &copy; 2020 COPTEST. Todos los derechos reservados.
        .col-md-6.text-center.text-md-right
          ul.list.ht-social-networks.solid-rounded-icon
            li.item
              a.hint--bounce.hint--top.hint--primary(href='https://twitter.com/Coptest_' target='_blank' aria-label='Twitter')
                i.fab.fa-twitter.link-icon
            li.item
              a.hint--bounce.hint--top.hint--primary(href='https://www.facebook.com/coptest/' target='_blank' aria-label='Facebook')
                i.fab.fa-facebook-f.link-icon
            li.item
              a.hint--bounce.hint--top.hint--primary(href='https://www.instagram.com/coptest_/' target='_blank' aria-label='Instagram')
                i.fab.fa-instagram.link-icon
            li.item
              a.hint--bounce.hint--top.hint--primary(href='https://t.me/joinchat/CG0L4g3SQ4EMMtqeomL1Bw' target='_blank' aria-label='Telegram')
                i.fab.fa-telegram.link-icon

</template>

<script type="text/javascript">
export default {
  name: "Footer",
  data() {
    return {};
  },
};
</script>
